<template>
  <div id="payment-page" class="payment-provider">
    <div class="payment-container">
      <div v-if="loadingCard" :ref="'card'" class="payment">

        <SfNotification :message="$t('errors.server.access')" :persistent="true" :visible="error" type="danger"/>

        <!--Hidden payment form -->
        <div v-if="!error">
          <div id="paymentForm" class="kr-embedded">

            <!-- payment form fields -->
            <div class="kr-pan"></div>
            <div class="kr-expiry"></div>
            <div class="kr-security-code"></div>

            <div class="terms">
               <span>En cliquant sur le bouton payer j'accepte
                <SfLink class="sf-button--text sf-button--underlined" link="/conditions-generales-de-vente"
                        target="_blank"> {{
                    $t('Terms and conditions')
                  }}
                </SfLink>
               </span>
            </div>

            <!-- payment form submit button -->

            <button class="kr-payment-button"></button>

            <!-- error zone -->
            <div class="kr-form-error"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import Api from "@/api/Api";
import scriptLoader from "@/utils/loadScript";

import {SfButton, SfCheckbox, SfIcon, SfLink, SfLoader, SfNotification,} from '@storefront-ui/vue';

export default {
  name: 'OrkSystemPayPayment',
  components: {
    SfNotification,
    SfCheckbox,
    SfButton,
    SfIcon,
    SfLink,
    SfLoader,
  },
  props: {
    hasShipping: {
      default: false,
      type: Boolean
    },
    hasBilling: {
      default: false,
      type: Boolean
    },
  },
  data() {
    return {
      error: false,
      loading: false,
      loadingCard: false,
    }
  },

  computed: {
    customer: {
      get() {
        return this.$store.getters.getProfile
      }
    },
    currentCart: {
      get() {
        return this.$store.getters.getCart
      },
    },
  },
  created() {
    this.loadScript();
  },

  watch: {
    currentCart(newCart) {
      if (newCart) {
        //this.initCheckout()
      }
    },
  },

  methods: {
    loadScript() {
      scriptLoader.loadJs("https://static.systempay.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js", "sysPay-KR", {
        label: 'kr-public-key',
        value: process.env.VUE_APP_SYSTEMPAY_USER + ':' + process.env.VUE_APP_SYSTEMPAY_KEY
      })
          .then(script => scriptLoader.loadJs("https://static.systempay.fr/static/js/krypton-client/V4.0/ext/classic.js", "sysPay-Client"))
          .then(script => scriptLoader.loadStyle("https://static.systempay.fr/static/js/krypton-client/V4.0/ext/classic-reset.css", "sysPay-Style"))
          .then(data => {
            this.initCheckout()
          }).catch((e)=>{
        this.error = true
      });
    },
    initCheckout() {
      Api.payment.initSystemPayForm().then((data) => {
        window.KR.setFormToken(data.formToken);
        // Add listener for submit event
        window.KR.onSubmit(this.submitPayment);
        this.error = false
      }).catch((e) => {
        this.error = true
      })
          .finally(() => {
            this.loadingCard = true;
          })
    },
    submitPayment(event) {
      if (event.clientAnswer.orderStatus === "PAID") {
          this.$router.push('/commande/merci/'+this.currentCart.id).catch(() => {})
      }
    },
  }
};

</script>

<style lang="scss" scoped>
.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
}

.payment-provider {
  .sf-radio {
    &__label {
      display: flex;
      justify-content: space-between;
    }

    &__description {
      --radio-description-margin: 0;
      --radio-description-font-size: var(--font-xs);
    }
  }

  #paymentForm {
    &.kr-embedded {
      width: 100%;

      .terms {
        display: block;

        span, a {
          font-size: 0.8rem;
          line-height: 0.8;
        }

        span {
          margin-bottom: 20px;

        }
      }

      * {
        font-family: var(--font-family--primary);
      }

      .kr-payment-button {
        font-family: var(--font-family--primary);
        border: 2px solid var(--c-primary);
        color: #fff;
        transition: 0.3s ease all;
        margin-top: 20px;
        background-color: var(--c-primary) !important;
        border-radius: 30px;
        height: 52px;
        font-weight: bold;

        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          color: var(--c-primary);
          background-color: #fff !important;
        }
      }

      .kr-field-element {
        border-width: 0 0 1px 0;
        border-color: var(--c-primary);
      }

      .kr-form-error {
        margin-top: 20px;
      }
    }

  }
}

.form {
  --button-width: 100%;
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    --button-width: auto;
  }

  &__action {
    @include for-desktop {
      flex: 0 0 100%;
      display: flex;
    }
  }

  &__action-button {
    &--secondary {
      @include for-desktop {
        order: -1;
        text-align: left;
      }
    }

    &--add-address {
      width: 100%;
      margin: 0;
      @include for-desktop {
        margin: 0 0 var(--spacer-lg) 0;
        width: auto;
      }
    }
  }

  &__back-button {
    margin: var(--spacer-xl) 0 var(--spacer-sm);

    &:hover {
      color: var(--c-white);
    }

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
    }
  }

  &__radio-group {
    flex: 0 0 100%;
    margin: 0 0 var(--spacer-xl) 0;
    @include for-desktop {
      margin: 0 0 var(--spacer-2xl) 0;
    }

  }
}
</style>
